import AdminAlert from "./AdminAlert"

type Props = {
  error?: string | null
  success?: string | null
  onClearError: () => void
  onClearSuccess: () => void
  successAutoDismissMs?: number
}

const AdminAlerts = ({
  error,
  success,
  onClearError,
  onClearSuccess,
  successAutoDismissMs = 6000,
}: Props) => {
  if (!error && !success) return null

  return (
    <div className="space-y-3">
      {error && <AdminAlert variant="error" message={error} onDismiss={onClearError} />}
      {success && (
        <AdminAlert
          variant="success"
          message={success}
          onDismiss={onClearSuccess}
          autoDismissMs={successAutoDismissMs}
        />
      )}
    </div>
  )
}

export default AdminAlerts
